import { useState } from "react";
import { Plus, Pencil, Trash2, Star } from "lucide-react";
import { ContactChannels } from "@/components/crm/Tags";
import { ContactDialog } from "@/components/crm/ContactDialog";

export const ContactsSection = ({ lead, onAdd, onEdit, onDelete, onMain, saving }) => {
  const [editing, setEditing] = useState(null); // null | {} (new) | contact
  const contacts = lead.contacts || [];
  const mainId = lead.main_contact?.id;
  const save = (c) => {
    const done = () => setEditing(null);
    if (editing?.id) onEdit(editing.id, c, done); else onAdd(c, done);
  };
  return (
    <section data-testid="contacts-section" className="rounded-2xl bg-white border border-slate-200 p-5">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-sm font-semibold text-slate-900">Contacts</h2>
        <button data-testid="contact-add" onClick={() => setEditing({})} className="h-10 px-4 rounded-full bg-slate-100 hover:bg-slate-200 text-sm font-medium inline-flex items-center gap-1.5 transition-colors">
          <Plus className="h-4 w-4" /> Add contact
        </button>
      </div>
      {contacts.length === 0 && <p className="text-sm text-slate-400 py-4">No contacts yet.</p>}
      <div className="divide-y divide-slate-100">
        {contacts.map((c, i) => {
          const isMain = c.id === mainId;
          return (
            <div key={c.id} data-testid={`contact-row-${i}`} className="py-3 flex items-start gap-3">
              <button data-testid={`contact-main-${i}`} title={isMain ? "Main contact" : "Make main contact"} onClick={() => !isMain && onMain(c.id)}
                className={`h-9 w-9 shrink-0 rounded-full flex items-center justify-center transition-colors ${isMain ? "bg-amber-100 text-amber-600" : "text-slate-300 hover:text-amber-500 hover:bg-amber-50"}`}>
                <Star className={`h-4 w-4 ${isMain ? "fill-current" : ""}`} />
              </button>
              <div className="flex-1 min-w-0">
                <p className="font-medium text-slate-900">{c.name || "Unnamed"}{c.designation && <span className="text-slate-500 font-normal"> · {c.designation}</span>}
                  {isMain && <span className="ml-2 text-[11px] font-semibold text-amber-700">MAIN</span>}</p>
                <div className="mt-1.5"><ContactChannels contact={c} testPrefix={`contact-${i}-mode`} /></div>
              </div>
              <button data-testid={`contact-edit-${i}`} onClick={() => setEditing(c)} className="h-9 w-9 rounded-full text-slate-400 hover:text-slate-900 hover:bg-slate-100 flex items-center justify-center"><Pencil className="h-4 w-4" /></button>
              <button data-testid={`contact-delete-${i}`} onClick={() => window.confirm(`Remove ${c.name || "this contact"}?`) && onDelete(c.id)} className="h-9 w-9 rounded-full text-slate-400 hover:text-rose-600 hover:bg-rose-50 flex items-center justify-center"><Trash2 className="h-4 w-4" /></button>
            </div>
          );
        })}
      </div>
      {editing && <ContactDialog contact={editing} onClose={() => setEditing(null)} onSave={save} saving={saving} />}
    </section>
  );
};
